import React from "react";
import {inject} from "mt-react-decorators";

@inject(['manager'])
export default class AveragesTable extends React.Component {

    get manager() {
        return this.props.manager;
    }

    get years() {
        const currentYear = new Date().getFullYear();

        let years = [];

        for (let yearCount = -5; yearCount <= 5; yearCount++){
            years.push(currentYear - yearCount);
        }

        return years;
    }

    renderOptions() {
        return this.years.map(year => {
            return (
                <option value={year} selected={year === this.manager.year}>
                    {year}
                </option>
            )
        });
    }

    changeYear(e) {
        this.manager.year = parseInt(e.target.value);
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__header-input mtt-sustainability-tool__header-input--year-picker'}>
                <label htmlFor="year-picker" className={'mtt-sustainability-tool__header-label tagline'}>Choose year</label>
                <select name="year-picker" onChange={(e) => this.changeYear(e)} className={'select'}>
                    {this.renderOptions()}
                </select>
            </div>
        );
    }
}